export const initialState = () => ({
  loading: {
    message: "",
    show: false
  },
  flow: {
    title: "",
    integrator: "",
    icon: "",
    saleFlow: [],
    roles: [],
    initialStatus: null,
    personType: [],
    hasScheduling: false
  },
  currentStep: 0,
  steps: ["Informações", "Funções"],
  stepsNamesRoutes: [
    "",
    "flow-information",
    "flow-roles",
  ],

  isCopying: false,
  isEditing: false,
  isSelectAllRoles: false,
  uuid: ""
})